import SwiperPartners from './swiper-partners';

export default SwiperPartners;
